export const stripHtmlTags = (html: string): string => {
  if (!html) {
    return ''
  }
  return html.replace(/<[^>]*>/g, '').trim()
}

export const hasHtmlTags = (text: string): boolean => {
  const htmlTagRegex = /<[^>]+>/g
  return htmlTagRegex.test(text)
}

export const capitalizeFirstLetter = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1)
